<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td
      v-for="filter in filters"
      :key="filter.field"
      class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
    >
      <v-text-field
        v-if="filter.type === 'text'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        type="text"
        @keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData(filter.field)"
      />
      
      <v-menu
        v-else-if="filter.type === 'date'"
        v-model="filter.menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :label="filter.label"
            v-model="filter.formatted"
            v-bind="attrs"
            @blur="updateDateValue(filter.field, filter.formatted)"
            v-on="on"
            hide-details="true"
            dense
            clearable
            @click:clear="clearFilterData(filter.field)"
          />
        </template>
        <v-date-picker
          v-model="searchData[filter.field]"
          no-title
          scrollable
          :max="today"
          @input="closeMenu(filter.field)"
        >
        <v-spacer />
          <v-btn text color="primary" @click="closeMenu(filter.field)">Cancel</v-btn>
        </v-date-picker>
      </v-menu>

      <v-select
        v-else-if="filter.type === 'select'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        :items="filter.items"
        item-text="text"
        item-value="value"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
      
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
import { formatDate, parseDate } from '../../../lib/helpers';
import { dataListEmailType, dataResendEmailStatus } from '../attributes';

export default {
  props: ['search', 'options'],
  data() {
    return {
      filters: [
        { label: 'Reference No', field: 'reference_number', type: 'text' },
        { label: 'MID', field: 'mid', type: 'text' },
        { label: 'Nama Merchant', field: 'merchant_name', type: 'text' },
        { label: 'MPAN', field: 'mpan', type: 'text' },
        { label: 'Email', field: 'receiver', type: 'text' },
        { label: 'Tipe Email', field: 'type', type: 'select', items: dataListEmailType },
        { label: 'Last Sent Date', field: 'last_resend_at', type: 'date', menu: false, formatted: '' },
        { label: 'Number of Resend', field: 'resend_count', type: 'text' },
        { label: 'Status', field: 'status', type: 'select', items: dataResendEmailStatus },
      ],
    };
  },
  computed: {
    today() {
      return new Date().toLocaleDateString('sv-SE');
    },
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
  },
  watch: {
    'searchData.last_resend_at': {
      handler(newVal) {
        const dateFilter = this.filters.find(f => f.field === 'last_resend_at');
        if (dateFilter) {
          dateFilter.formatted = formatDate(newVal);
        }
        this.getData();
      },
    },
  },
  beforeDestroy() {
    this.resetFilters();
  },
  methods: {
    resetFilters() {
      Object.keys(this.searchData).forEach(key => {
        this.searchData[key] = '';
      });
      this.getData();
    },
    clearFilterData(field) {
      this.searchData[field] = '';
      this.getData();
    },
    updateDateValue(field, formattedValue) {
      const parsedDate = parseDate(formattedValue);
      if (parsedDate) {
        this.searchData[field] = parsedDate;
      }
    },
    closeMenu(field) {
      const dateFilter = this.filters.find(f => f.field === field);
      if (dateFilter) {
        this.$set(dateFilter, 'menu', false);
      }
    },
    getData() {
      const newOptions = { ...this.options, page: 1 };
      this.$emit('update:options', newOptions);
      this.$emit('getDataParent');
    },
  },
};
</script>